<template>
  <div>
    <div class="schedule-ct">
      <schedule-selector-optimove-event
        v-if="
          model.type === campaignTypeEnum.TYPE_INAPP &&
            this.$store.state.app.integrations.optimove
        "
        :model="model"
      />
      <schedule-selector-optimove
        v-else-if="model.trigger === campaignTriggerTypes.TRIGGER_OPTIMOVE"
        :model="model"
      />
      <schedule-selector-salesforce
        v-else-if="model.trigger === campaignTriggerTypes.TRIGGER_SALESFORCE"
        :model="model"
      />
      <!-- Triggered or inApp campaign -->
      <schedule-selector-triggered v-else-if="model.trigger" :model="model" />

      <schedule-selector v-else :model="model" />

      <journey-options
        v-if="
          model.type === campaignTypeEnum.TYPE_WORKFLOW &&
            model.trigger !== campaignTriggerTypes.TRIGGER_LOCATION &&
            model.trigger !== campaignTriggerTypes.TRIGGER_EVENT &&
            model.send_type !== campaignSendTypeEnum.SEND_TYPE_NOW &&
            model.send_type !== campaignSendTypeEnum.SEND_TYPE_FUTURE &&
            hasMxaCampaignOptions
        "
        :model="model"
      />
    </div>

    <div class="footer">
      <div class="footer-ct">
        <el-button type="primary" @click="nextStep" data-qa="next-step-btn">
          {{ nextBtnLabel }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleSelector from '@/modules/campaign-manage/components/schedule/ScheduleSelector'
import ScheduleSelectorTriggered from '@/modules/campaign-manage/components/schedule/ScheduleSelectorTriggered'
import ScheduleSelectorOptimove from '@/modules/campaign-manage/components/schedule/ScheduleSelectorOptimove'
import ScheduleSelectorOptimoveEvent from '@/modules/campaign-manage/components/schedule/ScheduleSelectorOptimoveEvent'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'
import ScheduleSelectorSalesforce from '@/modules/campaign-manage/components/schedule/ScheduleSelectorSalesforce'
import { EventBus } from '@/core/EventBus'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import JourneyOptions from '@/modules/campaign-manage/components/schedule/JourneyOptions'
import { campaignSendTypeEnum } from '../../campaigns/enum/CampaignSendTypeEnums'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'StepSchedule',
  components: {
    JourneyOptions,
    ScheduleSelectorOptimoveEvent,
    ScheduleSelectorSalesforce,
    ScheduleSelectorOptimove,
    ScheduleSelectorTriggered,
    ScheduleSelector
  },
  data() {
    return {
      campaignTriggerTypes,
      campaignTypeEnum
    }
  },
  props: {
    model: {
      type: Object
    }
  },
  computed: {
    campaignSendTypeEnum() {
      return campaignSendTypeEnum
    },
    isTemplateCampaign() {
      return (
        this.$route.name === 'CreateTemplateCampaign' ||
        this.$route.name === 'UpdateTemplateCampaign' ||
        this.$route.name === 'CopyTemplateCampaign' ||
        this.$route.name === 'ViewTemplateCampaign'
      )
    },
    nextBtnLabel() {
      let index = 5
      if (
        this.model.trigger === campaignTriggerTypes.TRIGGER_LOCATION ||
        this.model.trigger === campaignTriggerTypes.TRIGGER_EVENT
      ) {
        index = 6
      }

      if (
        (this.$isRole('admin') ||
          this.$isRole('admin-support') ||
          this.$hasFeature('campaignContentPreview')) &&
        this.model.type === campaignTypeEnum.TYPE_NOTIFICATION &&
        !!this.model.email
      ) {
        return this.$t('CampaignForm_Schedule_NextButton_Title', {
          index: ++index
        })
      }

      if (this.isTemplateCampaign) {
        return this.$t('CampaignForm_Schedule_NextButton_SaveTemplate', {
          index: index
        })
      }

      return this.$t('CampaignForm_Schedule_NextButton_Title', { index: index })
    },
    hasMxaCampaignOptions() {
      return $hasFeature('mxaCampaignOptions')
    }
  },

  methods: {
    nextStep() {
      EventBus.$emit('campaign-create-next-step')
    }
  }
}
</script>

<style scoped>
.schedule-ct {
  padding-bottom: 60px;
}

.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  z-index: 1;
  border-top: 1px solid #e5e5e5;
}

.footer-ct {
  margin-right: 20px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/StepSchedule.vue